import React                        from 'react';
import { panelApproval as tooltip } from 'pu-data/Tooltips';
import CheckboxComponent            from './CheckboxComponent';

const PanelApproval = (props) => {
  const name = 'panel_approval';
  const { parameters } = props
  return (
    <div className="form-group">
      <CheckboxComponent
        name={name}
        inputId={name}
        label="Panel Approval"
        groupName={props.groupName}
        tooltip={props.tooltip}
        checked={parameters[name] === '1'}
        onChange={e => props.onChangeParameter(name, e.target.checked ? '1' : '0')} />
    </div>
  );
};

PanelApproval.defaultProps = {
  tooltip,
};

export default PanelApproval;
